import { twMerge } from "tailwind-merge";

const ArrowSvg = ({ className, color }) => (
  <svg
    className={twMerge(`icon icon-arrow icon--medium ${className}`)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 3.74121L13.75 9.99121L7.5 16.2412"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowSvg;
